module.exports = __webpack_public_path__ + "img/follow-up.bfd953ba.svg";